module.exports = __webpack_public_path__ + "static/media/defaultFont.5fcf34cc.webp";